import useLiveChat from '../../hooks/useLiveChat'

export default function IntercomManager() {
    useLiveChat()

    return null
}
